// Copyright (c) 2020 embyt GmbH. All rights reserved.

import * as React from "react";
import type { JSX } from "react";
import { connect } from "react-redux";
import { FormattedTime } from "react-intl";

import { IAction } from "actions";
import { IState } from "states/states";
import { getBrowserTimezoneOffset } from "guiutils";

interface IFormattedTimeExtProps {
  valueMs?: number; // ms
  valueS?: number; // s
  showSeconds?: boolean;
  doZeroPadding?: boolean;
  nullText?: string | JSX.Element;
  className?: string;
}

interface IFormattedTimeProps {
  adjTimestamp: number | undefined;
}

const mapStateToProps = (state: IState, ownProps: IFormattedTimeExtProps) => {
  let adjTimestamp;
  const ms = ownProps.valueMs ?? (ownProps.valueS ? 1000 * ownProps.valueS : undefined);
  if (ms) {
    // the timestamp will always be displayed in browser local time by the react FormattedTime component
    // thus, we need to fake the timestamp with the offset of the device compared to local timezone
    // derive offset in seconds
    const offset = state.site.tzOffset ? state.site.tzOffset + getBrowserTimezoneOffset() : 0;
    adjTimestamp = ms + 1000 * offset;
  }
  const props: IFormattedTimeProps = {
    adjTimestamp,
  };
  return props;
};

interface IFormattedTimeDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IFormattedTimeDispatch = {};
  return dispatchProps;
};

class FormattedTimeComponent extends React.Component<
  IFormattedTimeProps & IFormattedTimeExtProps & IFormattedTimeDispatch
> {
  public render() {
    if (this.props.adjTimestamp) {
      const timestamp = new Date(this.props.adjTimestamp);
      return (
        <span className={`nowrap ${this.props.className ?? ""}`}>
          <FormattedTime
            hour={this.props.doZeroPadding ? "2-digit" : "numeric"}
            minute={this.props.doZeroPadding ? "2-digit" : "numeric"}
            second={
              this.props.showSeconds ?
                this.props.doZeroPadding ?
                  "2-digit"
                : "numeric"
              : undefined
            }
            value={timestamp}
          />
        </span>
      );
    }
    if (this.props.nullText) {
      return <>{this.props.nullText}</>;
    }
    return <></>;
  }
}

const MyFormattedTime = connect(mapStateToProps, mapDispatchToProps)(FormattedTimeComponent);

export default MyFormattedTime;
